import request from '@/api/request'

export interface ContractTemplateBody {
  id: number
  content: string
}

export function fetchContractTemplate() {
  return request.get<ContractTemplateBody>('/api/admin/system/contract-template')
}

export function fetchCanonicalContractTemplate() {
  return request.get<ContractTemplateBody>('/api/admin/system/contract-template/default')
}

export function saveContractTemplate(content: string) {
  return request.put<{ status?: number; msg?: string }>('/api/admin/system/contract-template', { content })
}
